import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import App from "./App";
import { BrowserRouter as Router } from "react-router-dom";
import VConsole from "vconsole";
// import SentryInit from './utils/sentry'

// 禁用顶部分享按钮
// SentryInit()

if (
  process.env.REACT_APP_DELOY_ENV === "test" ||
  process.env.REACT_APP_ENV === "test"
) {
  new VConsole();
}

// if (process.env.NODE_ENV !== 'production') {
//   devtools.init()
// }

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <App />
    </Router>
  </React.StrictMode>,
  document.getElementById("root"),
);
